/* eslint-disable no-useless-escape */
import { HotelDatepicker } from "HotelDatepicker";
import datePicker from "../../../../../clientlibs/base/js/shared/datePicker";
import { datePickerProps } from "barcelo-shared/datePicker";

const calendar = {
  props: {
    cssSelector: "c-fastbooking__submenu-calendar",
    inputSelector: "c-fastbooking__calendar",
    calendarSelector: "c-fastbooking__calendar-wrapper",
    calendarRelatedSelector: "c-fastbooking__calendar-hotels-related-JS",
    numberNightSelector: "night-number-JS",
    dateStartJSselector: "date-start-JS",
    dateEndJSselector: "date-end-JS",
    numberNightSelectorWrapper: "submenu-calendar-header-select-number-JS",
    offerMessage: "offers-message-JS",
    tooltipSelector: "tooltip-JS-hotel-clossing",
    noDateSelector: "no-date-JS",
    classLoading: "mod--loading-dots",
    cssCalendarHeader: "submenu-calendar-header-JS",
    cssCalendarHeaderLegend: "calendar-header-legend-message-JS",

    containerSelectDateSelector: "select-date-JS",
    dateSelectSelector: "date-select-JS",
    deleteDateSelector: "delete-dates-JS",
    deleteHotelSelector: "delete-hotel-JS",

    inputHotelId: "destination-fb",
    parentInputDestination: "mod--destination",
    parentInputSelector: "mod--calendar",
    activeDateClass: "mod--active-delete",
    dateCheckin: "barcelo_FB_checkin",
    dateCheckout: "barcelo_FB_checkout",

    messageClosingHotelSelector: "message-fb-closing-hotel-JS",
    dayOpeningHotelSelector: "day-date-opening-JS",
    dayClosingHotelSelector: "day-date-closing-JS",
    monthOpeningHotelSelector: "month-date-opening-JS",
    monthClosingHotelSelector: "month-date-closing-JS",
    nameHotelSelector: "name-hotel-JS",
    buttonDateHotelOpenningSelector: "date-hotel-opening-JS",
    buttonDateHotelOpenningLegend: "date-dispo-hotel-JS",
    buttonRedirectHotelsRelateds: "redirect-relate-hotels-JS",
    calendarCampaignGroupSelector: "calendarcampaigngroup",
    relatedHotelIndex: "rel-",
    messageDateDispSelector: "message-fb-no-disp-JS",
    buttonDateDispSelector: "date-disp-JS",
    evtchangeRangeDate: "FBchangeRangeDate",
    midDay: "T12:00:00",
    options: {
      moveBothMonths: true,
      selectForward: true,
      startOfWeek: "monday",
      showTopbar: false,
      autoClose: false,
      enableCheckout: true,
      minNights: 1,
    },
    dataOfCurrentCheckinDay: null,
    dataOfCurrentCheckoutDay: null,
    disponibility: true,
    obj: null,
    $wrapper: null,
    $input: null,
    datesStorage: {},
    data: {
      startDate: null,
      endDate: null,
    },
    used: true,
    locale: null,
    dateOptions: { weekday: "short", day: "numeric", month: "short" },
    dateSelectOptions: { weekday: "short", day: "numeric", month: "short", year: "numeric" },
    countNoMonths: 0,
    updateOnlyCalendar: false,
    hideDeleteHotelOption: false,
    showOnlyCampaignPrices: false,
    acceptButtonCalendarJS: "acceptButtonCalendar-JS",
    destinationWasClicked: false,
    firstMonthLoaded: false,
  },

  init: function () {
    if (bcl.c.fastbooking.disabled) {
      delete bcl.c.fastbooking.calendar;
      return;
    }

    datePicker.init();

    const $container = bcl.c.fastbooking.commonProps.fastbooking.$container.querySelector("." + this.props.cssSelector);
    bcl.c.fastbooking.commonProps.calendar.$container = $container;

    const $tooltipContainer = bcl.c.fastbooking.commonProps.fastbooking.$container.querySelector("." + this.props.tooltipSelector);
    this.props.$tooltipContainer = $tooltipContainer;

    if (!this.initWrapper() || !this.initTabInput()) {
      return;
    }

    this.props.options.container = this.props.$wrapper;
    //Accesibility, should be called before HotelDatepicker is initialized
    this.initAriaLabels(this.props.$wrapper);
    if (bcl.c.fastbooking.commonProps.fastbooking.$container?.dataset.startday && bcl.c.fastbooking.commonProps.fastbooking.$container.dataset.startday === "1") {
      this.props.options.startOfWeek = "sunday";
    }

    this.initI18n();
    this.initData();

    // Check if there is a previous instance of HotelDatepicker and destroy it if necessary
    if (bcl.c.fastbooking.commonProps.calendar.obj) {
      bcl.c.fastbooking.commonProps.calendar.obj?.destroy?.(); // Destroy the previous instance
    }

    // Create a new instance of HotelDatepicker
    bcl.c.fastbooking.commonProps.calendar.obj = new HotelDatepicker(this.props.$input, this.props.options);

    bcl.c.fastbooking.commonProps.calendar.obj.callbackShowMonth = this.newDate.bind(this);
    bcl.c.fastbooking.commonProps.calendar.obj.callbackSetRangeDate = this.changeRangeDate.bind(this);

    bcl.c.fastbooking.commonProps.calendar.obj.open();

    this.initNodes();

    bcl.c.fastbooking.commonProps.calendar.location = bcl.c.fastbooking.commonProps.fastbooking.$container.dataset.locale;

    this.getInitCookies();
    if (this.roundedCalendarisEnabled()) {
      this.initAcceptButtonOnCalendar();
    }
    //Accesibility functions
    this.initCalendarAccesibility();
  },
  initCalendarAccesibility: function () {
    this.updateDatepickerAnnouncer();
    this.props.$wrapper?.querySelectorAll("*[role='button'].datepicker__month-button")?.forEach((btn) => {
      btn.addEventListener("keydown", (e) => {
        if (e.keyCode == 13 || e.keyCode == 32) {
          e.preventDefault();
          btn.click();
        }
      });
      btn.addEventListener("click", () => {
        this.props.firstMonthLoaded = false;
        this.updateDatepickerAnnouncer();
      });
    });
  },
  initDatePickerKeyboardNavigation: ($container) => {
    const dateGrid = ($container || bcl.c.fastbooking.commonProps.calendar.$container)?.querySelector(".datepicker");
    if (!dateGrid) {
      return;
    }
    const selector = ".datepicker__month-day--visibleMonth:not(.datepicker__month-day--invalid)";
    const allDays = Array.from(dateGrid?.querySelectorAll(selector));
    if (allDays?.length === 0) {
      return;
    }
    let firstElementToFocus, secondElementToFocus;

    const focusToElement = (el) => {
      el.setAttribute("tabindex", "0");
      // el.setAttribute("aria-current", "true");
      el.focus();
    };
    const moveFocusToCell = (cell, prevCell) => {
      if (prevCell) {
        if (prevCell != firstElementToFocus && prevCell != secondElementToFocus) {
          prevCell.removeAttribute("tabindex");
        }
        // prevCell.removeAttribute("aria-current");
      }
      focusToElement(cell);
    };
    //CHECK IF THIS IS NEEDED
    const moveToSameDayOfWeek = (currentIndex, direction) => {
      if (!Array.isArray(allDays) || !allDays[currentIndex]) {
        return currentIndex;
      }
      const currentDayElement = allDays[currentIndex];
      if (!currentDayElement) {
        return currentIndex;
      }
      const currentTimeAttr = currentDayElement.getAttribute("time");
      if (!currentTimeAttr) {
        return currentIndex;
      }

      const currentTimestamp = parseInt(currentTimeAttr, 10);
      const currentJsDate = new Date(currentTimestamp);

      const enabledDaysByNormalizedDate = new Map();
      allDays.forEach((dayEl, idx) => {
        const timeAttr = dayEl.getAttribute("time");
        if (timeAttr) {
          const dateFromAttr = new Date(parseInt(timeAttr, 10));
          dateFromAttr.setHours(0, 0, 0, 0);
          enabledDaysByNormalizedDate.set(dateFromAttr.getTime().toString(), idx);
        }
      });
      const searchDate = new Date(currentJsDate);
      searchDate.setHours(0, 0, 0, 0);

      const maxSearchAttempts = 10;

      for (let i = 0; i < maxSearchAttempts; i++) {
        if (direction === "prev") {
          searchDate.setDate(searchDate.getDate() - 7);
        } else if (direction === "next") {
          searchDate.setDate(searchDate.getDate() + 7);
        } else {
          return currentIndex;
        }

        const targetNormalizedTimestamp = searchDate.getTime().toString();
        const targetIndex = enabledDaysByNormalizedDate.get(targetNormalizedTimestamp);

        if (typeof targetIndex === "number") {
          return targetIndex;
        }
      }
      return currentIndex;
    };

    const handleDateKeyDown = (e) => {
      const key = e.key;
      const current = e.currentTarget;

      const index = allDays.indexOf(current);
      let newIndex = index;

      const currentRow = current.closest("tr");
      const rowDays = Array.from(currentRow.querySelectorAll(selector));

      switch (key) {
        case "ArrowRight":
          e.preventDefault();
          newIndex = index + 1;
          break;
        case "ArrowLeft":
          e.preventDefault();
          newIndex = index - 1;
          break;
        case "ArrowUp":
          e.preventDefault();
          newIndex = moveToSameDayOfWeek(index, "prev");
          break;
        case "ArrowDown":
          e.preventDefault();
          newIndex = moveToSameDayOfWeek(index, "next");
          break;
        case "Home":
          e.preventDefault();
          if (rowDays?.length > 0) {
            const firstInRow = rowDays[0];
            newIndex = allDays.indexOf(firstInRow);
          }
          break;
        case "End":
          e.preventDefault();
          if (rowDays?.length > 0) {
            const lastInRow = rowDays[rowDays.length - 1];
            newIndex = allDays.indexOf(lastInRow);
          }
          break;
        case "Enter":
        case " ":
          e.preventDefault();
          current.click();
          return;
        default:
          return;
      }
      e.preventDefault();
      if (newIndex >= 0 && newIndex < allDays.length) {
        moveFocusToCell(allDays[newIndex], allDays[index]);
      }
    };

    dateGrid.querySelectorAll("tr")?.forEach((row) => row.setAttribute("role", "row"));

    allDays.forEach((cell) => {
      cell.setAttribute("role", "gridcell");
      if (firstElementToFocus == null && (cell.querySelector("#currentday") || cell.querySelector("#startday") || cell)) {
        firstElementToFocus = cell;
      }
      if (secondElementToFocus == null && cell.closest(".datepicker__month--month2")) {
        secondElementToFocus = cell;
      }
      if (cell.dataset.eventAdded === "true") {
        return;
      }
      cell.dataset.eventAdded = "true";
      cell.addEventListener("keydown", handleDateKeyDown);
      cell.addEventListener("focusout", (e) => {
        const current = e.currentTarget;
        if (current) {
          current != firstElementToFocus && current != secondElementToFocus && current.removeAttribute("tabindex");
          //  && current.removeAttribute("aria-current");
        }
      });
    });
    const fromButton = document.activeElement?.classList?.contains("datepicker__month-button") && !document.activeElement?.classList?.contains("datepicker__month-button--disabled");
    const firstBtn = dateGrid.querySelector("*[role='button'].datepicker__month-button--prev:not(.datepicker__month-button--disabled)");
    if (firstBtn) {
      firstBtn.setAttribute("tabindex", "0");
      !fromButton && firstBtn.focus();
    }
    if (firstElementToFocus) {
      firstElementToFocus.setAttribute("tabindex", "0");
      if (!firstBtn) {
        !fromButton && focusToElement(firstElementToFocus);
      } else {
        firstElementToFocus.setAttribute("tabindex", "0");
      }
    }
    if (secondElementToFocus) {
      secondElementToFocus.setAttribute("tabindex", "0");
    }
  },
  updateDatepickerAnnouncer: function () {
    const $containerDateSelect = this.props.$containerDateSelect || bcl.c.fastbooking.commonProps.calendar.$container;
    if (!$containerDateSelect) {
      return;
    }
    const announcer = $containerDateSelect.querySelector("#datepickerAnnouncer");
    if (announcer) {
      let selector = ".datepicker__month-caption .datepicker__month-name";
      if(bcl.u.mobile.isMobile()) {
        selector = ".datepicker__month--month1 .datepicker__month-caption .datepicker__month-name";
      }
      const monthsName = $containerDateSelect.querySelectorAll(selector);
      if (!monthsName || monthsName.length === 0) {
        return;
      }
      let text;
      monthsName.forEach((monthName, index) => {
        index === 0 ? (text = monthName.innerText) : (text += ", " + monthName.innerText);
      });
      announcer.innerText = text;
    }
  },
  initAriaLabels: function ($calendarContainer) {
    if (datePickerProps?.ariaLabels?.findDataOfCurrentDay) {
      return;
    }
    if (!$calendarContainer) {
      return;
    }
    datePickerProps.ariaLabels = {
      currentDay: $calendarContainer.dataset.ariaCurrent,
      startDay: $calendarContainer.dataset.ariaStart,
      endDay: $calendarContainer.dataset.ariaEnd,
      inRange: $calendarContainer.dataset.ariaRange,
    };
  },
  initAcceptButtonOnCalendar: function () {
    const acceptButton = document.querySelector("." + this.props.acceptButtonCalendarJS);
    if (acceptButton) {
      acceptButton.addEventListener("click", function () {
        //check Nights
        const nightsSelected = bcl.c.fastbooking.commonProps.calendar.obj.getNights();
        if (nightsSelected === 0) {
          bcl.c.fastbooking.calendar.showHideSelectDateMsg(true);
          bcl.c.fastbooking.calendar.showHideNumberNights(true);
        } else {
          //close calendar
          bcl.c.fastbooking.calendar.showHideSelectDateMsg(false);
          bcl.c.fastbooking.calendar.showHideNumberNights(true);
          bcl.c.fastbooking.closeCalendar();
        }
      });
    }
  },

  roundedCalendarisEnabled: function () {
    const squaredElement = document.querySelector(".mod--enabledrounded");
    let isSquared = false;
    if (squaredElement) {
      isSquared = true;
    }
    return isSquared;
  },

  showHideSelectDateMsg: function (show) {
    const msgSpan = document.querySelector(".select-calendar-date-msg-JS");
    if (msgSpan) {
      if (show) {
        bcl.u.removeClass(msgSpan, "hidden");
      } else {
        bcl.u.addClass(msgSpan, "hidden");
      }
    }
  },

  showHideNumberNights: function (show) {
    const msgSpanTotalNight = document.querySelector(".night-number-JS");
    const msgSpanWord = document.querySelector(".night-number-word-JS");
    if (msgSpanTotalNight && msgSpanWord) {
      if (show) {
        bcl.u.addClass(msgSpanTotalNight, "hidden");
        bcl.u.addClass(msgSpanWord, "hidden");
      } else {
        bcl.u.removeClass(msgSpanTotalNight, "hidden");
        bcl.u.removeClass(msgSpanWord, "hidden");
      }
    }
  },

  initI18n: function () {
    this.props.options.i18n = {};

    const obj = {
      $container: bcl.c.fastbooking.commonProps.fastbooking.$container,
      props: this.props.options.i18n,
      parser: this.parseParamsI18n,
    };

    obj.name = "weekdays";
    obj.nameSave = "day-names";
    this.initItem(obj);

    obj.name = "shortWeekdays";
    obj.nameSave = "day-names-short";
    this.initItem(obj);

    obj.name = "months";
    obj.nameSave = "month-names";
    this.initItem(obj);

    obj.name = "shortMonths";
    obj.nameSave = "month-names-short";
    this.initItem(obj);

    obj.name = "dayNumbers";
    obj.nameSave = "day-numbers";
    this.initItem(obj);

    delete obj.parser;

    obj.name = "i18nNight";
    obj.nameSave = "night";
    this.initItem(obj);

    obj.name = "i18nNights";
    obj.nameSave = "nights";
    this.initItem(obj);
  },

  initItem: function (obj) {
    if (!obj?.name || !obj.nameSave) {
      return;
    }

    const $container = this.getContainerInProps(obj.$container);

    if ($container?.dataset[obj.name]) {
      const props = obj.props || this.props;
      let value = $container.dataset[obj.name];

      if (obj.parser) {
        value = obj.parser(value);
      }

      props[obj.nameSave] = value;
    }
  },

  parseParamsI18n: function (value) {
    return value?.split(",").filter(Boolean);
  },

  initData: function () {
    this.initItem({ name: "lowestprice", nameSave: "classNameMinPrice", props: datePickerProps });
    this.initItem({ name: "lowestpricepercentage", nameSave: "percentageMinPrice", props: datePickerProps });
    this.initItem({ name: "halfprice", nameSave: "classNamePrice", props: datePickerProps });
    this.initItem({ name: "highestprice", nameSave: "classNameMaxPrice", props: datePickerProps });
    this.initItem({ name: "highestpricepercentage", nameSave: "percentageMaxPrice", props: datePickerProps });
  },

  getContainerInProps: function ($container) {
    if (!$container) {
      return bcl.c.fastbooking.commonProps.calendar.$container;
    } else if (typeof $container === "string") {
      return this.props[$container];
    }

    return $container;
  },

  initNode: function (selector, name, $container) {
    $container = this.getContainerInProps($container);

    if (!$container) {
      return;
    }

    const $node = $container.getElementsByClassName(this.props[selector]);

    if ($node?.length) {
      this.props[name] = $node[0];
    }
  },

  initNodesSelectDates: function () {
    this.initNode("containerSelectDateSelector", "$containerDateSelect");
    this.initNode("dateSelectSelector", "$dateSelect", "$containerDateSelect");
    this.initNode("noDateSelector", "$noDate", "$containerDateSelect");
    this.initNode("numberNightSelector", "$nightNumber", "$containerDateSelect");
    this.initNode("numberNightSelectorWrapper", "$nightNumberWrapper", "$containerDateSelect");
    this.initNode("dateStartJSselector", "$dateStartJSselector", "$containerDateSelect");
    this.initNode("dateEndJSselector", "$dateEndJSselector", "$containerDateSelect");
    this.initNode("offerMessage", "$offerMessage");
  },

  initNodesDeleteDates: function () {
    this.initNode("deleteDateSelector", "$deleteDates", bcl.c.fastbooking.commonProps.fastbooking.$container);

    if (this.props.$deleteDates) {
      this.props.$deleteDates.addEventListener("click", () => {
        this.cleanDatesFastBooking();
        bcl.c.fastbooking?.commonProps?.calendar?.$startDate?.focus();
      });
    }
  },

  cleanDatesFastBooking: function () {
    this.deleteDates();
    window.dispatchEvent(new CustomEvent(bcl.c.fastbooking.commonProps.calendar.evtchangeRangeDate));
    bcl.c.fastbooking.commonProps.calendar.dataDest && bcl.c.fastbooking.changeButton(bcl.c.fastbooking.commonProps.calendar.dataDest.type == "hotel" ? "booking" : "search");
  },

  initNodesDeleteHotel: function () {
    this.initNode("deleteHotelSelector", "$deleteHotel", bcl.c.fastbooking.commonProps.fastbooking.$container);

    if (this.props.$deleteHotel) {
      this.props.$deleteHotel.addEventListener("click", () => {
        this.deleteHotel();
        bcl.c.fastbooking.commonProps.calendar.dataDest && bcl.c.fastbooking.changeButton(bcl.c.fastbooking.commonProps.calendar.dataDest.type == "hotel" ? "booking" : "search");
        bcl.c.fastbooking?.commonProps?.destination?.$destinationInput?.focus();
      });
    }
  },

  deleteDates: function () {
    this.clearDates();
    this.applyRemoveAtAll([this.props.dateCheckout, this.props.dateCheckin]);
  },

  deleteHotel: function () {
    this.setValueInput("hotel", null);
    bcl.c.fastbooking.commonProps.destination.lastLabel = "";
    bcl.c.fastbooking.commonProps.destination.data = null;
    bcl.c.fastbooking.commonProps.calendar.dataDest = null;
    !bcl.c.fastbooking.commonProps.calendar.hideDeleteHotelOption && bcl.u.removeClass(bcl.c.fastbooking.commonProps.calendar.$parentDestination, this.props.activeDateClass);
  },

  initNodesMessageClosingHotel: function () {
    this.initNode("messageClosingHotelSelector", "$messageClosingHotel");
    this.initNode("dayClosingHotelSelector", "$dayClosingHotel", "$messageClosingHotel");
    this.initNode("monthClosingHotelSelector", "$monthClosingHotel", "$messageClosingHotel");
    this.initNode("dayOpeningHotelSelector", "$dayOpeningHotel", "$messageClosingHotel");
    this.initNode("dayOpeningHotelSelector", "$tooltipDayOpeningHotel", "$tooltipContainer");
    this.initNode("monthOpeningHotelSelector", "$monthOpeningHotel", "$messageClosingHotel");
    this.initNode("monthOpeningHotelSelector", "$tooltipMonthOpeningHotel", "$tooltipContainer");
    this.initNode("nameHotelSelector", "$nameHotel", "$messageClosingHotel");
    this.initNode("nameHotelSelector", "$tooltipNameHotel", "$tooltipContainer");
    this.initNode("buttonDateHotelOpenningSelector", "$buttonDateHotelOpenning", "$messageClosingHotel");
    this.initNode("buttonDateHotelOpenningLegend", "$buttonDateHotelOpenningLegend");
    this.initNode("buttonRedirectHotelsRelateds", "$buttonRedirectHotelsRelateds");

    if (this.props.$buttonDateHotelOpenning) {
      this.props.$buttonDateHotelOpenning.addEventListener("click", () => {
        this.goToDate(this.props.lastDateHotelopening);
        this.deleteDates();
        this.showOrHideRelateds();
      });
    }

    if (this.props.$buttonDateHotelOpenningLegend) {
      this.props.$buttonDateHotelOpenningLegend.addEventListener("click", () => {
        this.goToDate(this.props.lastDateHotelopening);
        this.deleteDates();
        this.showOrHideRelateds();
      });
    }

    if (this.props.$buttonRedirectHotelsRelateds) {
      this.props.$buttonRedirectHotelsRelateds.addEventListener("click", () => {
        bcl.c.fastbooking.redirectHotelsRelateds();
      });
    }
  },

  initNodesMessageNoDisp: function () {
    this.initNode("messageDateDispSelector", "$messageDateDisp");
    this.initNode("buttonDateDispSelector", "$buttonDateDisp", "$messageDateDisp");

    if (this.props.$buttonDateDisp) {
      this.props.$buttonDateDisp.addEventListener("click", () => {
        this.goToDate(this.props.lastDateDisp);
      });
    }
  },

  initNodes: function () {
    this.initInputs();
    this.initNodesSelectDates();
    this.initNodesDeleteDates();
    this.initNodesDeleteHotel();
    this.initNodesMessageClosingHotel();
    this.initNodesMessageNoDisp();
  },

  goToDate: function (date) {
    if (!date) {
      return;
    }

    bcl.c.fastbooking.commonProps.calendar.obj.showMonth(date, 1);

    const date2 = bcl.u.getNormalizedDate(date.getTime());

    date2.setMonth(date2.getMonth() + 1);
    bcl.c.fastbooking.commonProps.calendar.obj.showMonth(date2, 2);
    bcl.c.fastbooking.commonProps.calendar.obj.disableNextPrevButtons();
  },

  initInputs: function () {
    const $parentInput = bcl.c.fastbooking.commonProps.fastbooking.$container.querySelector("." + this.props.parentInputSelector);
    const $parentDestination = bcl.c.fastbooking.commonProps.fastbooking.$container.querySelector("." + this.props.parentInputDestination);

    const inputs = $parentInput.querySelectorAll(".js-calendar-date");

    this.props.$parentInput = $parentInput;
    bcl.c.fastbooking.commonProps.calendar.$parentDestination = $parentDestination;
    bcl.c.fastbooking.commonProps.calendar.hideDeleteHotelOption = $parentDestination.dataset.hidedeletehotel;
    bcl.c.fastbooking.commonProps.calendar.$startDate = inputs[0];
    bcl.c.fastbooking.commonProps.calendar.$endDate = inputs[1];

    this.changePlaceholderStartDate();

    this.props.$endDate = inputs[1];

    const inputHotel = bcl.c.fastbooking.commonProps.fastbooking.$container.querySelector("#" + this.props.inputHotelId);
    this.props.$hotel = inputHotel;

    this.initInput(inputs[0], "startDate");
    this.initInput(inputs[1], "endDate");
    this.initInput(inputHotel, "hotel");

    this.props.inputs = inputs;
  },

  changePlaceholderStartDate: function () {
    if (!bcl.u.mobile.isMobile() && bcl.c.fastbooking.commonProps?.calendar?.$startDate?.dataset?.desktopPlaceholder) {
      bcl.c.fastbooking.commonProps.calendar.$startDate.value = bcl.c.fastbooking.commonProps.calendar.$startDate.dataset.desktopPlaceholder;
    } else if (bcl.c.fastbooking.commonProps?.calendar?.$startDate?.dataset?.defaultPlaceholder) {
      bcl.c.fastbooking.commonProps.calendar.$startDate.value = bcl.c.fastbooking.commonProps.calendar.$startDate.dataset.defaultPlaceholder;
    }
    if (bcl.c.fastbooking.commonProps?.calendar?.$endDate?.placeholder) {
      bcl.c.fastbooking.commonProps.calendar.$endDate.value = bcl.c.fastbooking.commonProps.calendar.$endDate.placeholder;
    }
  },

  updateInputs: function (obj) {
    const startDateInput = this.props.inputs[0],
      endDateInput = this.props.inputs[1];

    startDateInput.setAttribute("value", obj.startDate);
    startDateInput.value = obj.startDate;
    this.inputChange(startDateInput, "startDate");

    endDateInput.setAttribute("value", obj.endDate);
    endDateInput.value = obj.endDate;
    this.inputChange(endDateInput, "endDate");
  },

  initInput: function ($input, key) {
    $input.addEventListener("change", () => {
      this.inputChange($input, key);
    });
  },

  inputChange: function ($input, key) {
    this.correctCalendarDates(false);
    const value = $input.value,
      date = bcl.u.getNormalizedDate(value);

    if (!value || date == "Invalid Date" || date < bcl.u.getNormalizedDate()) {
      this.clearDates();
      return;
    }

    bcl.c.fastbooking.commonProps.calendar.data[key] = this.parseDate(date);

    this.updateWithInputsValue();
  },

  updateWithInputsValue: function () {
    if (bcl.c.fastbooking.commonProps.calendar.data.startDate && bcl.c.fastbooking.commonProps.calendar.data.endDate) {
      bcl.c.fastbooking.commonProps.calendar.obj.setRange(bcl.c.fastbooking.commonProps.calendar.data.startDate, bcl.c.fastbooking.commonProps.calendar.data.endDate);

      this.setRangeDate(bcl.c.fastbooking.commonProps.calendar.data.startDate, bcl.c.fastbooking.commonProps.calendar.data.endDate);
    }
  },

  initWrapper: function () {
    const $wrapper = bcl.c.fastbooking.commonProps.calendar.$container.getElementsByClassName(this.props.calendarSelector);

    if (!$wrapper?.[0]) {
      return false;
    }

    this.props.$wrapper = $wrapper[0];
    return true;
  },

  initTabInput: function () {
    const $input = this.props.$wrapper.getElementsByClassName(this.props.inputSelector);

    if (!$input?.[0]) {
      return false;
    }

    this.props.$input = $input[0];

    return true;
  },
  updateDataDest: function (data) {
    if (!data) {
      return;
    }

    bcl.c.fastbooking.commonProps.calendar.dataDest = data;

    bcl.c.fastbooking.changeButton(data.type == "hotel" ? "booking" : "search");

    this.props.datesStorage = {};

    const startDate = bcl.c.fastbooking.commonProps.calendar.obj.month1,
      endDate = bcl.c.fastbooking.commonProps.calendar.obj.month2;

    this.initDate = {
      startDate: startDate,
      endDate: endDate,
    };

    this.props.newDate = true;
    bcl.c.fastbooking.commonProps.calendar.destinationWasClicked = bcl.c.fastbooking.destination.destinationWasClicked(data);
    this.props.firstMonthLoaded = false;
    // Optimization: Desktop calendar shows 2 months but mobile shows only 1 month
    this.newDate(startDate, 1);
    if (!bcl.u.mobile.isMobile() || !bcl.u.mobile.isTablet()) {
      // Mobile calendar only shows the first month
      this.newDate(endDate, 2);
    }
  },

  monthsAreConsecutive: function (startDate, endDate) {
    const DECEMBER = 11;
    const JANUARY = 0;
    const month1Number = startDate.getMonth();
    const month1Year = startDate.getFullYear();
    const month2Number = endDate.getMonth();
    const month2Year = endDate.getFullYear();
    return (month1Year === month2Year && month2Number - month1Number === 1) || (month2Year - month1Year === 1 && month1Number === DECEMBER && month2Number == JANUARY);
  },

  correctCalendarDates: function (clickFromDestinationFbInput) {
    if (clickFromDestinationFbInput || Object.keys(bcl.c.fastbooking.commonProps.calendar.obj).length === 0) {
      const startDate = new Date();
      let endDate = new Date();
      endDate = new Date(endDate.setMonth(startDate.getMonth() + 1));
      bcl.c.fastbooking.commonProps.calendar.obj.month1 = startDate;
      bcl.c.fastbooking.commonProps.calendar.obj.month2 = endDate;
    } else {
      const startDate = bcl.c.fastbooking.commonProps.calendar.obj.month1;
      let endDate = bcl.c.fastbooking.commonProps.calendar.obj.month2;

      if (!this.monthsAreConsecutive(startDate, endDate)) {
        endDate = new Date(endDate.setMonth(startDate.getMonth() + 1));
        bcl.c.fastbooking.commonProps.calendar.obj.month2 = endDate;
      }
    }

    bcl.c.fastbooking.commonProps.calendar.obj.showMonth(bcl.c.fastbooking.commonProps.calendar.obj.month1, 1, true);
    bcl.c.fastbooking.commonProps.calendar.obj.showMonth(bcl.c.fastbooking.commonProps.calendar.obj.month2, 2, true);
  },

  processMessageClosingHotel: function (startDate, endDate, resetDate) {
    if (resetDate === 3 || resetDate === 1) {
      this.props.activeMessage = false;
    }

    const item = bcl.c.fastbooking.commonProps.calendar.dataDest?.data;

    if (!item?.openingDate) {
      this.noMessageClosingHotel();
      return;
    }

    let hotelclosing = null;
    const hotelopening = bcl.u.getNormalizedDate(item.openingDate);

    if (item.closingDate && item.closingDate != "") {
      hotelclosing = bcl.u.getNormalizedDate(item.closingDate);
    }

    if (this.hotelIsClosed(hotelclosing, hotelopening, endDate)) {
      this.props.activeMessage = true;
      bcl.c.fastbooking.commonProps.calendar.dataMessage = {
        hotelclosing: hotelclosing,
        hotelopening: hotelopening,
      };

      this.updateMessageClosingHotel(hotelclosing, hotelopening, endDate <= hotelopening);
      this.hotelRelatedLogic(endDate, hotelopening);
    } else if (!hotelclosing && startDate < hotelopening) {
      this.props.activeMessage = true;
      bcl.c.fastbooking.commonProps.calendar.dataMessage = {
        hotelclosing: null,
        hotelopening: hotelopening,
      };

      if (this.areFromSameMonth(hotelopening, startDate)) {
        this.noMessageClosingHotel();
      } else {
        this.updateMessageClosingHotel(hotelclosing, hotelopening, endDate <= hotelopening);
      }
      this.hotelRelatedLogic(endDate, hotelopening);
    } else if (resetDate !== 2) {
      this.noMessageClosingHotel();
    }
  },
  areFromSameMonth(date1, date2) {
    if (!date1 || !date2) {
      return false;
    }

    if (date1.getYear() === date2.getYear()) {
      return date1.getMonth() === date2.getMonth();
    }
    return false;
  },

  hotelRelatedLogic: function (endDate, hotelopening) {
    if (bcl.c.hotelRelated?.props.componentLoader) {
      if (bcl.c.fastbooking.commonProps.calendar.dataDest.id === bcl.c.hotelRelated.props.hotel.dataset.hotel) {
        this.showOrHideRelateds(true);
        bcl.c.hotelRelated.hideOrSHowComponent(bcl.c.fastbooking.commonProps.calendar.$container.querySelector(".embed-JS"), bcl.c.fastbooking.commonProps.calendar.$container.querySelector(".related-JS"), "post", "fastbookin", endDate <= hotelopening);
      }
    }
  },

  goToNextMonth: function () {
    bcl.u.addClass(this.props.$offerMessage, "hidden");
  },

  hotelIsClosed: function (hotelclosing, hotelopening, date) {
    let isClosed = false;
    if (hotelopening && date < hotelopening && !hotelclosing) {
      //Hotel closed
      isClosed = true;
    }
    return isClosed;
  },

  noMessageClosingHotel: function () {
    bcl.c.fastbooking.commonProps.calendar.dataMessage = null;
    this.props.activeMessage = false;
    bcl.u.addClass(this.props.$messageClosingHotel, "hidden");
    this.showMessageContainer();

    if (bcl.c.fastbooking.calendar.roundedCalendarisEnabled()) {
      const legendBox = document.querySelector(".submenu-calendar-header-JS");
      if (legendBox) {
        bcl.u.removeClass(legendBox, "hidden");
      }
    }
  },

  noMessageClosingHotelWithDates: function () {
    bcl.u.addClass(this.props.$messageClosingHotel, "hidden");
    this.showMessageContainer();
  },

  updateMessageClosingHotel: function (hotelclosing, hotelopening, activeButton) {
    const nameHotel = bcl.c.fastbooking.commonProps.calendar.dataDest.data.hotelName || bcl.c.fastbooking.commonProps.calendar.dataDest.data.publicName || bcl.c.fastbooking.commonProps.calendar.dataDest.label || "Hotel";

    if (!bcl.c.fastbooking.calendar.roundedCalendarisEnabled()) {
      this.props.$nameHotel.innerText = nameHotel;
    }

    this.props.$tooltipNameHotel.innerText = nameHotel;
    const $message = this.props.$messageClosingHotel.querySelector(".closing-message-hotel-JS");

    if (hotelclosing) {
      bcl.u.removeClass($message, "hidden");
      this.props.$dayClosingHotel.innerText = hotelclosing.getDate();
      this.props.$monthClosingHotel.innerText = bcl.c.fastbooking.commonProps.calendar.obj.i18n["month-names"][hotelclosing.getMonth()];
    } else {
      bcl.u.addClass($message, "hidden");
      if (bcl.c.fastbooking.calendar.roundedCalendarisEnabled()) {
        bcl.u.removeClass($message, "hidden");
        const legendBox = document.querySelector(".submenu-calendar-header-JS");
        if (legendBox) {
          bcl.u.addClass(legendBox, "hidden");
        }
      }
    }

    if (hotelopening) {
      const openingDay = hotelopening.getDate();
      const openingMonth = bcl.c.fastbooking.commonProps.calendar.obj.i18n["month-names"][hotelopening.getMonth()];
      this.props.$dayOpeningHotel.innerText = openingDay;
      this.props.$tooltipDayOpeningHotel.innerText = openingDay;

      this.props.$monthOpeningHotel.innerText = openingMonth;
      this.props.$tooltipMonthOpeningHotel.innerText = openingMonth;
      this.props.lastDateHotelopening = hotelopening;
    }

    if (activeButton) {
      bcl.u.removeClass(this.props.$buttonDateHotelOpenning, "hidden");
      this.showHideTextNightsCountWrapper("hide");
      bcl.u.removeClass(this.props.$messageClosingHotel, "hidden");
    } else {
      bcl.u.addClass(this.props.$buttonDateHotelOpenning, "hidden");
      bcl.u.removeClass(this.props.$messageClosingHotel, "hidden");
    }
  },

  showMessageContainer: function ($container) {
    bcl.u.addClass(this.props.$messageDateDisp, "hidden");

    if ($container) {
      !this.props.activeMessage && bcl.u.removeClass(this.props[$container], "hidden");
    } else if (!this.props.activeMessage) {
      bcl.u.removeClass(this.props.$containerDateSelect, "hidden");
    }
  },

  newDate: function (startDate, resetDate) {
    if (!bcl.c.fastbooking.commonProps.destination.url) {
      return;
    }

    startDate = bcl.u.getNormalizedDate(startDate);
    const date = bcl.u.getNormalizedDate();

    if (date > startDate) {
      startDate = date;
    }

    const endDate = this.updateToLastDayMonth(new Date().setFullYear(startDate.getFullYear(), startDate.getMonth(), 1));
    this.processMessageClosingHotel(startDate, endDate, resetDate);

    this.request(startDate, endDate, resetDate);
  },

  updateToLastDayMonth: function (dateString) {
    const date = bcl.u.getNormalizedDate(dateString);

    date.setMonth(date.getMonth() + 1);
    date.setDate(0);

    return date;
  },

  parseDate: function (date) {
    if (!date) {
      return "";
    }

    return date.toISOString().split("T")[0];
  },

  request: function (startDate, endDate, resetDate) {
    const parsedStartDate = this.parseDate(startDate);
    const parsedEndDate = this.parseDate(endDate);

    let data = this.props.datesStorage[parsedStartDate + "|" + parsedEndDate];
    if (data && data.currency != bcl.s.currency.props.currency.current) {
      data = null;
    }
    this.props.lastDates = {
      startDate: parsedStartDate,
      endDate: parsedEndDate,
    };

    bcl.s.datePicker.clearPricesDates(this.props.$wrapper);

    if (bcl.u.containsClass(bcl.c.fastbooking.commonProps.calendar.$container, "mod--active")) {
      bcl.u.addBhgLoading(bcl.c.fastbooking.commonProps.calendar.$container, true);
    }

    if (!data && !bcl.c.fastbooking.commonProps.calendar?.destinationWasClicked) {
      this.props.isCubanHotel = bcl.c.fastbooking.commonProps.destination.data?.countryData?.countryName == "Cuba" || (typeof utag_data != "undefined" && utag_data?.hotel_country == "cuba");
      bcl.u.addClass(this.props.$wrapper, this.props.classLoading);

      const isResort = isNaN(parseInt(bcl.c.fastbooking.commonProps.calendar?.dataDest?.id));

      if (this.props.isCubanHotel || this.checkOldSabreApi() || isResort) {
        const sabreUrl = this.getSabreUrl(new Date(parsedStartDate), new Date(parsedEndDate));
        if (sabreUrl == null || sabreUrl == undefined) {
          return;
        }
        bcl.ajax.getRequest(null, sabreUrl, this.loadData.bind(this), {
          dates: [parsedStartDate, parsedEndDate],
          resetDate: resetDate,
          lastDates: {
            startDate: parsedStartDate,
            endDate: parsedEndDate,
          },
        });
        return;
      }

      const url = this.getUrl(startDate, endDate);

      if (!url) {
        return;
      }
      const config = { headers: { "X-CBE-Customer-Currency": bcl.s.currency.props.currency.current } };
      fetch(url, config)
        .then((res) => res.text())
        .then((data) => {
          this.loadData(
            { response: data },
            {
              dates: [parsedStartDate, parsedEndDate],
              resetDate: resetDate,
              lastDates: {
                startDate: parsedStartDate,
                endDate: parsedEndDate,
              },
            },
          );
        });
    } else {
      if (bcl.c.fastbooking.commonProps.calendar?.destinationWasClicked) {
        data = {};
      }
      setTimeout(() => {
        this.loadData(data, {
          resetDate: resetDate,
          lastDates: {
            startDate: parsedStartDate,
            endDate: parsedEndDate,
          },
        });
      }, 10);
    }
  },

  getUrl: function (startDate, endDate) {
    const dateParams = new URLSearchParams({
      start_date: this.parseDate(startDate),
      end_date: this.parseDate(endDate),
      market: document.querySelector("body").getAttribute("data-ratefilter"),
    });
    const { id } = bcl.c.fastbooking.commonProps.calendar.dataDest || {};
    if (id == undefined || id == null || isNaN(parseInt(id))) {
      return;
    }

    const url = document?.body?.dataset?.bconnectUrl ? document.body.dataset.bconnectUrl.replace("[HOTEL_ID]", id) + "/by-dates?" + dateParams.toString() : undefined;

    this.props.url = url;
    return url;
  },

  getSabreUrl: function (startDate, endDate) {
    const url = bcl.c.fastbooking.commonProps.destination.url,
      data = bcl.c.fastbooking.commonProps.calendar.dataDest;

    if (!url || !data || !data.id) {
      return;
    }

    let selectors = (data.selector || "calendar") + ".",
      id = data.id + ".",
      type = "id" + ".",
      code = data.code + ".",
      coupon = "",
      promo = "";

    if (data.type == "group") {
      type = data.type + ".";
    }

    if (data.type != "group" && bcl.c.fastbooking.commonProps.discount.data.promocode && bcl.c.fastbooking.commonProps.discount.data.promocode.value) {
      selectors = "calendarpromo" + ".";
      coupon = bcl.c.fastbooking.commonProps.discount.data.promocode.value + ".";
      code = "";
      type = "";
    }

    if (data.type != "group" && bcl.c.fastbooking.commonProps.discount.data.promo && bcl.c.fastbooking.commonProps.discount.data.promo.value) {
      selectors = this.props.calendarCampaignGroupSelector + ".";
      promo = bcl.c.fastbooking.commonProps.discount.data.promo.value + ".";
      code = "";
      type = "";
    }

    if (this.isNoDispo(startDate.getTime())) {
      id = this.props.relatedHotelIndex + id;
      coupon = "";
      code = data.code + ".";
      selectors = "calendar" + ".";
      type = "group" + ".";
    }

    if (data.selector) {
      if (bcl.c.fastbooking.commonProps.discount.data.promo?.value) {
        selectors += id + code + promo;
      } else {
        selectors += id + code + coupon;
      }
    } else {
      selectors += type + (data.data?.noCalendar ? "0" + "." : id) + coupon;
    }

    selectors += this.parseDate(startDate).replace(/[-\/]/g, "") + ".";
    selectors += this.parseDate(endDate).replace(/[-\/]/g, "") + ".";

    if (this.isNoDispo(startDate.getTime(), endDate.getTime())) {
      selectors += this.parseDate(bcl.c.fastbooking.commonProps.calendar.dataMessage.hotelopening).replace(/[-\/]/g, "") + ".";
    }

    if (data.type !== "group" && bcl.c.fastbooking.commonProps.discount.data.promo && bcl.c.fastbooking.commonProps.discount.data.promo.value) {
      selectors += bcl.c.fastbooking.commonProps.discount.data.promo.selector + ".";
    }

    const currency = bcl.s.currency.props.currency.current || bcl.s.currency.props.currency.market;
    selectors += currency + ".";

    this.props.url = url;
    return url.replace("json", selectors + "json");
  },

  updateUrl: function () {
    const url = bcl.c.fastbooking.commonProps.destination.url,
      data = bcl.c.fastbooking.commonProps.calendar.dataDest;
    let selectors = (data.selector || "calendar") + ".",
      id = data.id,
      type = "id";

    if (data.type === "group") {
      type = data.type;
    }

    if (data.data.noDispo && data.id !== bcl.c.fastbooking.commonProps.fastbooking.isHotel) {
      id = this.props.relatedHotelIndex + id;
      type = "group";
    }

    if (data.selector) {
      selectors += id + "." + data.code + ".";
    } else {
      selectors += type + "." + (data.data?.noCalendar ? "0" : id) + ".";
    }

    this.props.url = url.replace("json", selectors + "json");
  },

  isNoDispo: function (startDate, endDate, hotelId) {
    const data = bcl.c.fastbooking.commonProps.calendar.dataDest;
    endDate = endDate || false;

    if (
      data.type == "hotel" &&
      data.data.noDispo &&
      bcl.c.fastbooking.commonProps.calendar.dataMessage &&
      bcl.c.fastbooking.commonProps.calendar.dataMessage.hotelopening &&
      startDate < bcl.c.fastbooking.commonProps.calendar.dataMessage.hotelopening.getTime()
    ) {
      if (data.id !== bcl.c.fastbooking.commonProps.fastbooking.isHotel || hotelId === bcl.c.fastbooking.commonProps.fastbooking.isHotel || bcl.u.containsClass(document.body, "hotel-listing")) {
        if (!endDate || (endDate && bcl.c.fastbooking.commonProps.calendar.dataMessage.hotelopening.getTime() < endDate)) {
          return true;
        }
      }
    }

    return false;
  },
  showCalendarHeader: function () {
    const calHeader = document.querySelector(".c-fastbooking__submenu-calendar-header-JS");
    bcl.u.removeClass(calHeader, "hidden");
  },
  hideCalendarHeader: function () {
    const calHeader = document.querySelector(".c-fastbooking__submenu-calendar-header-JS");
    bcl.u.addClass(calHeader, "hidden");
  },
  showOrHideRelateds: function (show, forceShowCalendar) {
    const $related = bcl.c.fastbooking.commonProps.calendar.$container.querySelector("." + bcl.c.fastbooking.commonProps.calendar.calendarRelatedSelector);
    const $legend = bcl.c.fastbooking.commonProps.calendar.$container.querySelector("." + this.props.cssCalendarHeaderLegend);
    if (show) {
      bcl.u.addClass(this.props.$wrapper, "hidden");

      if (typeof forceShowCalendar !== "undefined" && forceShowCalendar) {
        bcl.u.removeClass(this.props.$wrapper, "hidden");
      }

      bcl.u.removeClass($related, "hidden");
      bcl.u.removeClass($legend, "hidden");
      this.removeLegends($legend);
      bcl.u.removeClass(this.props.$messageClosingHotel, "hidden");
      bcl.u.removeClass(this.props.cssCalendarHeaderLegend, "hidden");
      bcl.u.removeClass(this.props.$buttonDateHotelOpenning, "hidden");
    } else {
      bcl.u.removeClass(this.props.$wrapper, "hidden");
      bcl.u.addClass($related, "hidden");
      bcl.u.addClass($legend, "hidden");
      this.showLegends($legend);
      bcl.u.addClass(this.props.$messageClosingHotel, "hidden");
      bcl.u.removeClass(this.props.cssCalendarHeaderLegend, "hidden");
      bcl.u.addClass(this.props.$buttonDateHotelOpenning, "hidden");
    }
  },

  changeRangeDate: function (startDate, endDate) {
    const data = bcl.c.fastbooking.commonProps.calendar.dataDest;

    const close = bcl.c.fastbooking.calendar.setRangeDate(startDate, endDate);

    window.dispatchEvent(new CustomEvent(bcl.c.fastbooking.commonProps.calendar.evtchangeRangeDate));

    bcl.c.fastbooking.changeButton(data.type == "hotel" ? "booking" : "search");
    if (bcl.c.fastbooking.calendar.isNoDispo(startDate)) {
      bcl.c.fastbooking.changeButton("search");
    }

    if (!close) {
      return;
    }

    if (!bcl.c.fastbooking.calendar.props.used) {
      bcl.s.tabs.openNext();
      bcl.c.fastbooking.calendar.props.used = true;
    } else {
      if (!bcl.c.fastbooking.calendar.roundedCalendarisEnabled()) {
        bcl.c.fastbooking.closeCalendar();
      }
    }
  },

  setRangeDate: function (startDate, endDate) {
    if (!startDate || !endDate) {
      this.clearDates();
      return;
    }

    startDate = bcl.u.getNormalizedDate(startDate);
    endDate = bcl.u.getNormalizedDate(endDate);

    this.setValueInput("startDate", startDate);
    this.setValueInput("endDate", endDate);

    this.updateDataNodes(startDate, endDate);

    if (bcl.c.hotelRoomList) {
      bcl.c.fastbooking.commonProps.calendar.updateOnlyCalendar = true;
      bcl.c.fastbooking.updateFBDynamically();
    }
    return true;
  },

  clearDates: function () {
    this.setValueInput("startDate", null);
    this.setValueInput("endDate", null);
    this.changePlaceholderStartDate();
    this.updateDataNodes(null, null, true);

    bcl.c.fastbooking.commonProps.calendar.obj.clear();
    bcl.c.fastbooking.rooms.cleanRooms();
    if (bcl.c.fastbooking.calendar.roundedCalendarisEnabled()) {
      this.props.$nightNumber.innerText = "0";
    } else {
      this.props.$nightNumber.innerText = "";
    }

    this.props.$dateEndJSselector.innerText = "";
    this.props.$dateStartJSselector.innerText = "";
    this.showHideTextNightsCountWrapper("hide");
  },

  cleanCalendar: function () {
    this.clearDates();
    bcl.c.fastbooking.commonProps.calendar.obj.disabledDates = [];
    if (this.props.$wrapper) {
      bcl.u.listAddClass(this.props.$wrapper.getElementsByClassName("datepicker__month-day"), "datepicker__month-day--valid");
      bcl.u.listRemoveClass(this.props.$wrapper.getElementsByClassName("datepicker__month-day"), ["datepicker__month-day--invalid", "datepicker__month-day--disabled", "tooltip-JS", "mod--loaded"]);
    }
  },
  writeStartDate: function (startDate) {
    this.props.$dateSelect.children[0].innerText = this.parseDateForInput(startDate, "dateSelectOptions");
    bcl.u.removeClass(this.props.$dateSelect, bcl.c.fastbooking.props.hiddenClass);
    bcl.u.addClass(this.props.$noDate, bcl.c.fastbooking.props.hiddenClass);
    bcl.u.addClass(this.props.$parentInput, this.props.activeDateClass);

    this.showHideTextNightsCount(true);
    this.resetTextNightsCount();

    !this.props.hideDeleteHotelOption && bcl.u.addClass(this.props.$parentDestination, this.props.activeDateClass);
  },
  resetTextNightsCount: function () {
    const span = document.querySelectorAll(".night-number-JS"); //<-- TEST
    if (span && span.length > 0) {
      span[0].innerHTML = "";
    }
  },
  showHideTextNightsCount: function (show) {
    if (show) {
      bcl.u.removeClass(this.props.$nightNumber.parentNode, bcl.c.fastbooking.props.hiddenClass);
    } else {
      bcl.u.addClass(this.props.$nightNumber.parentNode, bcl.c.fastbooking.props.hiddenClass);
    }
  },

  showHideTextNightsCountWrapper: function (show) {
    if (show == "show") {
      bcl.u.removeClass(this.props.$nightNumberWrapper, bcl.c.fastbooking.props.hiddenClass);
    } else if (show == "hide") {
      bcl.u.addClass(this.props.$nightNumberWrapper, bcl.c.fastbooking.props.hiddenClass);
    }
  },
  updateDataNodes: function (startDate, endDate, noNight) {
    const countNight = noNight ? 0 : bcl.c.fastbooking.commonProps.calendar.obj.getNights();

    this.props.$nightNumber.innerText = countNight;

    if (countNight) {
      this.props.$dateSelect.children[0].innerText = this.parseDateForInput(startDate, "dateSelectOptions");
      this.props.$dateSelect.children[2].innerText = this.parseDateForInput(endDate, "dateSelectOptions");

      bcl.u.removeClass(this.props.$dateSelect, bcl.c.fastbooking.commonProps.fastbooking.hiddenClass);
      bcl.u.addClass(this.props.$noDate, bcl.c.fastbooking.commonProps.fastbooking.hiddenClass);
      bcl.u.addClass(this.props.$parentInput, bcl.c.fastbooking.commonProps.calendar.activeDateClass);
      !bcl.c.fastbooking.commonProps.calendar.hideDeleteHotelOption && bcl.u.addClass(bcl.c.fastbooking.commonProps.calendar.$parentDestination, bcl.c.fastbooking.commonProps.calendar.activeDateClass);

      return;
    }

    bcl.u.addClass(this.props.$dateSelect, bcl.c.fastbooking.commonProps.fastbooking.hiddenClass);
    bcl.u.removeClass(this.props.$noDate, bcl.c.fastbooking.commonProps.fastbooking.hiddenClass);
    bcl.u.removeClass(this.props.$parentInput, bcl.c.fastbooking.commonProps.calendar.activeDateClass);
  },

  setValueInput: function (keyInput, value) {
    if (!keyInput) {
      return;
    }

    const $input = keyInput === "startDate" ? bcl.c.fastbooking.commonProps.calendar.$startDate : this.props["$" + keyInput];

    bcl.c.fastbooking.commonProps.calendar.data[keyInput] = bcl.u.formatDate(value);

    const valueDate = this.parseDateForInput(value);

    $input.setAttribute("value", valueDate);
    $input.value = valueDate;
  },

  parseDateForInput: function (date, options) {
    if (!date) {
      return "";
    }

    if (options && this.props[options]) {
      options = this.props[options];
    }

    if (!options) {
      options = this.props.dateOptions;
    }

    return date.toLocaleDateString(bcl.c.fastbooking.commonProps.calendar.location, options).replace(".", "");
  },

  loadData: function (res, obj) {
    if (!res || res.code) {
      bcl.u.removeBhgLoading(bcl.c.fastbooking.commonProps.calendar.$container);
      return;
    }

    let data;
    const dates = obj.dates;

    if (dates && !bcl.c.fastbooking.commonProps.calendar?.destinationWasClicked) {
      if (!res.response) {
        bcl.u.removeBhgLoading(bcl.c.fastbooking.commonProps.calendar.$container);
        return;
      }

      data = JSON.parse(res.response);

      if (!this.props.isCubanHotel && data.dates) {
        data = data.dates.map((date) => {
          return {
            Amount: bcl.u.formatPriceDecimals(date.rates.minimum, true) ?? 0,
            AmountWithTaxesFees: bcl.u.formatPriceDecimals(date.rates.minimum) ?? 0,
            day: date.date,
            closed: date.restriction.status == "CLOSED",
            minStay: date.restriction.status == "MIN_STAY" ? date.restriction.quantity : false,
            noArrival: date.restriction.status == "NO_ARRIVAL",
          };
        });

        data = { prices: data, noCalendar: false, errorApi: Object.prototype.hasOwnProperty.call(res, "code"), currency: bcl.s.currency.props.currency.current };
      }

      this.setDateInStorage(dates, data);

      bcl.u.removeClass(this.props.$wrapper, this.props.classLoading);
    } else {
      data = res;
    }

    if (data?.prices?.length) {
      this.showMessageContainer();
      this.isCubanHotel(data.prices[0]);
    }

    bcl.s.currency.evaluateRelativeMarketRate(data);

    bcl.s.datePicker.noArrivalDates(bcl.c.fastbooking.commonProps.calendar.obj, data, obj.lastDates);
    bcl.s.datePicker.disabledDates(bcl.c.fastbooking.commonProps.calendar.obj, obj.resetDate, data, obj.lastDates);
    bcl.s.datePicker.setDates(this.props.$wrapper, data, bcl.c.fastbooking.commonProps.calendar.dataOffer, this.props.newDate, this.isCorrelatedHotelPrice(res));

    this.props.newDate = false;

    //accesibility
    this.callDatePickerArrowFunctionality(this.props.$wrapper);
    bcl.u.removeBhgLoading(bcl.c.fastbooking.commonProps.calendar.$container);
  },
  callDatePickerArrowFunctionality: function ($wrapper) {
    if (this.props.firstMonthLoaded === false) {
      this.props.firstMonthLoaded = true;
      return;
    }
    if (this.props.firstMonthLoaded === true) {
      this.initDatePickerKeyboardNavigation($wrapper);
    }
  },
  setDateInStorage: function (dates, data) {
    if (this.initDate) {
      const startDate = this.initDate.startDate,
        lastDayStartDate = this.parseDate(this.updateToLastDayMonth(startDate));

      this.props.datesStorage[dates[0] + "|" + lastDayStartDate] = data;

      const endDate = this.parseDate(this.initDate.endDate);

      this.props.datesStorage[endDate + "|" + dates[1]] = data;

      this.initDate = null;
      return;
    }

    this.props.datesStorage[dates[0] + "|" + dates[1]] = data;
  },

  readCookies: function () {
    const dateCheckIn = bcl.cookie.get(this.props.dateCheckin),
      dateCheckout = bcl.cookie.get(this.props.dateCheckout);

    if (!dateCheckIn || !dateCheckout) {
      return {};
    }

    return {
      startDate: dateCheckIn,
      endDate: dateCheckout,
    };
  },

  getInitCookies: function () {
    bcl.c.fastbooking.commonProps.calendar.data = this.readCookies();

    if (!bcl.c.fastbooking.commonProps.calendar.data.startDate || !bcl.c.fastbooking.commonProps.calendar.data.endDate) {
      return;
    }

    this.updateWithInputsValue();
  },

  addCookies: function () {
    const data = bcl.c.fastbooking.commonProps.calendar.data;

    if (!data) {
      return;
    }

    let dateCheckIn = data.startDate,
      dateCheckout = data.endDate;

    if (bcl.cookie.get(this.props.dateCheckin) !== dateCheckIn || bcl.cookie.get(this.props.dateCheckout) !== dateCheckout) {
      if (!dateCheckIn) {
        dateCheckIn = "";
        dateCheckout = "";
      } else if (dateCheckout) {
        dateCheckIn += this.props.midDay;
        dateCheckout += this.props.midDay;
      } else {
        dateCheckIn += this.props.midDay;
      }

      bcl.c.fastbooking.setCookies(this.props.dateCheckin, dateCheckIn);
      bcl.c.fastbooking.setCookies(this.props.dateCheckout, dateCheckout);
    }
  },

  applyRemoveAtAll: function (cookies) {
    bcl.u.forEach(cookies, (cookie) => {
      this.removeCookie(cookie);
    });
  },

  removeCookie: function (nameCookie) {
    bcl.cookie.remove(nameCookie, "/");
  },

  resize: function () {
    this.changePlaceholderStartDate();
  },

  closeTab: function () {
    bcl.s.tooltip.closeActive();
  },

  isCubanHotel: function (price) {
    if (price && price.Amount < 0) {
      this.removeLegends();
    } else {
      this.showLegends();
    }
  },

  isCorrelatedHotelPrice: function (res) {
    if (res?.responseURL) {
      return res.responseURL.includes("." + this.props.relatedHotelIndex);
    }
  },

  getLegends: function () {
    return {
      priceColorLegend: bcl.c.fastbooking.commonProps.calendar.$container.querySelector(".c-fastbooking__submenu-calendar-header-legend-labels"),
      priceLegend: bcl.c.fastbooking.commonProps.calendar.$container.querySelector(".c-fastbooking__submenu-calendar-prices-room"),
    };
  },

  removeLegends: function () {
    const legends = this.getLegends();
    if (!bcl.u.containsClass(bcl.c.fastbooking.commonProps.calendar.$container.querySelector("." + this.props.cssCalendarHeaderLegend), "hidden")) {
      bcl.u.addClass(legends.priceColorLegend, "hidden");
      bcl.u.addClass(legends.priceLegend, "hidden");
    }
  },

  showLegends: function () {
    const legends = this.getLegends();
    if (bcl.u.containsClass(bcl.c.fastbooking.commonProps.calendar.$container.querySelector("." + this.props.cssCalendarHeaderLegend), "hidden")) {
      bcl.u.removeClass(legends.priceColorLegend, "hidden");
      bcl.u.removeClass(legends.priceLegend, "hidden");
    }
  },

  compareRibbonsMsg: function () {
    const closingHotelMessage = document.querySelector("." + this.props.messageClosingHotelSelector),
      parentOfClosingMessage = closingHotelMessage ? closingHotelMessage.closest("." + this.props.cssCalendarHeader) : "",
      legend = document.querySelector("." + this.props.cssCalendarHeaderLegend);

    if (parentOfClosingMessage && !bcl.u.containsClass(legend, "hidden")) {
      const RibbonWithMsgActive = parentOfClosingMessage.querySelector(".c-adv:not(.hidden)"),
        diffBetweenRibbons = RibbonWithMsgActive && legend ? legend.offsetHeight - RibbonWithMsgActive.offsetHeight : null;

      diffBetweenRibbons && this.setSameHeightInMsg(legend, Math.abs(diffBetweenRibbons));
    }
  },

  setSameHeightInMsg: function (legend, diffBetweenRibbons) {
    legend.style.paddingTop = parseInt(getComputedStyle(legend).paddingTop.replace("px", "")) - diffBetweenRibbons / 2 + "px";
    legend.style.paddingBottom = parseInt(getComputedStyle(legend).paddingBottom.replace("px", "")) - diffBetweenRibbons / 2 + "px";
  },

  checkDisponibility: function (dataOfCurrentCheckDay) {
    let isDisponibility = true;

    if ((dataOfCurrentCheckDay.closed || (dataOfCurrentCheckDay.AmountWithTaxesFees === 0 && dataOfCurrentCheckDay.Amount === 0)) && !bcl.c.fastbooking.commonProps.fastbooking.disabledPrices) {
      isDisponibility = false;
    }

    return isDisponibility;
  },

  findedAllValuesForCheckDate: function (dateCheckout, dateCheckin) {
    let finded = false;

    if (dateCheckin && dateCheckout) {
      finded = this.props.dataOfCurrentCheckinDay && this.props.dataOfCurrentCheckoutDay ? true : finded;
    } else if (dateCheckin && this.props.dataOfCurrentCheckinDay) {
      finded = true;
    } else if (dateCheckout && this.props.dataOfCurrentCheckoutDay) {
      finded = true;
    }

    return finded;
  },

  findDataOfCurrentDay: function (dateCheck, dataOfCurrentCheckDay, listOfRangeCalendarCalls, listOfDayOnCalendarCalls) {
    if (dateCheck >= listOfRangeCalendarCalls[0] && dateCheck < listOfRangeCalendarCalls[1] && Array.isArray(listOfDayOnCalendarCalls?.prices)) {
      this.props[dataOfCurrentCheckDay] = listOfDayOnCalendarCalls.prices.find(function (o) {
        return o.day === dateCheck;
      });
    }
  },

  finderOfDisponibilityToCurrentCheckDays: function () {
    let dateCheckin = bcl.cookie.get(this.props.dateCheckin),
      dateCheckout = bcl.cookie.get(this.props.dateCheckout);
    const listOfCalendarCalls = Object.entries(this.props.datesStorage);

    dateCheckin = dateCheckin ? dateCheckin.split("T")[0] : "";
    dateCheckout = dateCheckout ? dateCheckout.split("T")[0] : "";

    this.props.dataOfCurrentCheckinDay = "";
    this.props.dataOfCurrentCheckoutDay = "";

    if (!dateCheckin && !dateCheckout) {
      return;
    }

    for (const element of listOfCalendarCalls) {
      dateCheckin && this.findDataOfCurrentDay(dateCheckin, "dataOfCurrentCheckinDay", element[0].split("|"), element[1]);

      const dayBeforeCheckout = new Date(new Date(dateCheckout) - 86400000);
      dayBeforeCheckout && this.findDataOfCurrentDay(dayBeforeCheckout.toISOString().split("T")[0], "dataOfCurrentCheckoutDay", element[0].split("|"), element[1]);

      if (this.findedAllValuesForCheckDate(dateCheckin, dateCheckout)) {
        break;
      }
    }

    if (this.props.dataOfCurrentCheckinDay || this.props.dataOfCurrentCheckoutDay) {
      this.updateDisponibility();
    }
  },

  updateDisponibility: function () {
    bcl.c.fastbooking.commonProps.calendar.disponibility = true;
    const hasCheckoutDisponibility = this.checkDisponibility(this.props.dataOfCurrentCheckoutDay);
    const isCampaignGroup = bcl.c.fastbooking.isCampaignGroup();
    const lastHour = bcl.s.datePicker.timezoneCondition() && !this.props.dataOfCurrentCheckinDay;

    if (lastHour) {
      if (!hasCheckoutDisponibility && !isCampaignGroup) {
        bcl.c.fastbooking.commonProps.calendar.disponibility = false;
      }
    } else {
      const hasCheckinDisponibility = this.checkDisponibility(this.props.dataOfCurrentCheckinDay);
      if (!hasCheckinDisponibility || (!hasCheckoutDisponibility && !isCampaignGroup)) {
        bcl.c.fastbooking.commonProps.calendar.disponibility = false;
      }
    }
  },

  checkOldSabreApi: function () {
    return document.body.classList.contains("mod--enable-sabre-API-calendar") || document.querySelector("html")?.dataset?.template == "campaign-group";
  },
};

export default calendar;
